import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import { Autocomplete, Button, TextField } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import {
  MedicalCenterDisplayEnum,
  MedicalCenterEnum,
  ProcessCardEnum,
  ProcessCardPassportEnum,
  ProcessCardEnumDisplayLabel,
  ProcessEnumDisplayLabel,
  ProcessCardPassportEnumDisplayLabel
} from "../../Types/Enum";
import { useSnackbar } from "notistack";

const ProcessCardDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [processCard, setProcessCard] = useState(props.data);
  const [value, setValue] = useState({});
  const [medicalCenterList, setMedicalCenterList] = useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();

  useEffect(() => {
    setProcessCard(props.data);
  }, [props.data]);


  useEffect(() => {
    getMedicalCentersList();
  }, []);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const editProcessView = async (data: any) => {

    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process-card/${data.id}`;

    axiosInstance
      .put(url, {
        // process_id: processCard.process_id,
        // pro_card_template_id: data.country_process_card_tpl.id,
        // resume_id: processCard.resume_id,
        status: data.status,
        ref_id: 1,
        note: data.note,
        remark: "Text",
      })
      .then((response) => {

      })
      .catch((err: any) => {
        enqueueSnackbar("Process Card Updation Unsuccessful!!!", {
          variant: "error",
        });
      });
    enqueueSnackbar("Process Card Updated Successfully!!!", {
      variant: "success",
    });


    handleClose();
  };
  const refresh = () => {
    // it re-renders the component
    setValue({});
  };
  const getMedicalCentersList = async () => {
    try {
      const response = await axiosInstance.get(`/v1/medical-centers`, {});

      const data = response.data;

      setMedicalCenterList(data.result);

    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {" "}
      {processCard == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit :{props.data.id}</DialogTitle>
          ) : (
            <><DialogTitle>Process Card : {props.data.id}</DialogTitle></>
          )}

          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={processCard}
              initialTouched={{ zip: true }}
              onSubmit={editProcessView}
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-1 ">
                  <div className="flex flex-col space-y-1 mb-4 mt-2">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={processCard.country_process_card_tpl.title == 'passport' ? [
                        ProcessCardPassportEnum.notchanged,
                        ProcessCardPassportEnum.collected,
                        ProcessCardPassportEnum.returned,
                      ] : [
                        ProcessCardEnum.processing,
                        ProcessCardEnum.completed,
                        ProcessCardEnum.approved,
                        ProcessCardEnum.rejected,
                      ]}
                      getOptionLabel={(option) => processCard.country_process_card_tpl.title == 'passport' 
                      ? ProcessCardPassportEnumDisplayLabel[option]
                      : ProcessCardEnumDisplayLabel[option]}
                      onChange={(e, value) => setFieldValue("status", value)}
                      value={values.status} // Set the value prop here
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="status"
                          label="Status"
                          required
                          value={values.status}
                          placeholder={
                            values == ""
                              ? "Processing"
                              : ProcessEnumDisplayLabel[processCard.status]
                          }
                          error={Boolean(
                            touched.status && errors.status
                          )}
                          helperText={
                            errors.status &&
                            touched.status &&
                            String(errors.status)
                          }
                        />
                      )}
                    />
                  </div>
                  {processCard.country_process_card_tpl.title ==
                    "Medical Certificate" ? (
                    <>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={[
                          MedicalCenterEnum.KMED_KURUNEGALA,
                          MedicalCenterEnum.GOLDMED_KURUNEGALA,
                          MedicalCenterEnum.KURUNEGALA_DIAGNOSTIC_CENTER,
                          MedicalCenterEnum.V_CARE_MEDICAL_KURUNEGALA,
                          MedicalCenterEnum.LEAP_MEDICAL_KURUNEGALA,
                        ]}
                        getOptionLabel={(option) =>
                          MedicalCenterDisplayEnum[option]
                        }
                        value={values.ref_id}
                        onChange={(e, value) => setFieldValue("ref_id", value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="ref_id"
                            label="Medical Centers"
                            // onChange={handleChange}
                            value={values.ref_id}
                            placeholder={
                              values == ""
                                ? ""
                                : MedicalCenterDisplayEnum[processCard.ref_id]
                            }
                            error={Boolean(
                              touched.ref_id && errors.ref_id
                            )}
                            helperText={
                              errors.ref_id &&
                              touched.ref_id &&
                              String(errors.ref_id)
                            }
                          />
                        )}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="flex flex-col space-y-1 mb-4">
                    <TextField
                      id="outlined-multiline-flexible"
                      multiline
                      label="Note"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.note || ""}
                      placeholder="Enter the Note"
                      name="note"
                      error={Boolean(errors.note && touched.note)}
                      helperText={
                        errors.note && touched.note && String(errors.note)
                      }
                    />
                  </div>

                  <div className="flex py-3 px-3 space-x-4 justify-end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Update
                    </Button>

                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ProcessCardDialogBox;
